module.exports = __webpack_public_path__ + "img/Collaboration.cb663012.png";